import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Routes } from '@angular/router';

import { UserService, SeedDataService, ProfileDataService} from '../../Services/index';

import {TreeModule, TreeNode, InputTextModule, ButtonModule, DialogModule, Message} from 'primeng/primeng';

import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

//import {ROUTER_DIRECTIVES, RouteConfig} from '@angular/router';

import {SelectItem, AutoCompleteModule, ConfirmationService} from 'primeng/primeng';

import { BusinessUnit } from '../../Models/BusinessUnit';

import { } from 'rxjs';
import { Profile } from '../../Models/profile.model';

@Component({
    templateUrl: './delivery.unit.html'
})

export class DeliveryunitComponent implements OnInit {
    timer: any = 0;
    delay: number = 200;
    IsDoubleClick: boolean = false;
    public Label: string;
    public ButtonCaption: string;
    public loading: boolean;
    public files: TreeNode[];
    public treedata: TreeNode[];
	public tData: any;
    public selectedFiles: TreeNode[];
    public selectedFile: any;
    public trees = {};
    public selectedNodes: any;
    public hrBusinessParterSelectItem: SelectItem[];
    public unitManagerTeamMemberSelectedItem: SelectItem[];
    public addDisable = true;
    public editDisable = true;
    public deleteDisable = true;

    public modelDialoglDisplay: boolean = false;
    public AddFor: string = '';
    public UnitName: any;

    public bussinessUnit: BusinessUnit;
    selectedBusinessUnit: BusinessUnit;

    newBusinessUnit: boolean;

    bussinessUnits: BusinessUnit[];

    msgs: Message[] = [];

    userform: BusinessUnit;

    submitted: boolean;
    profiles: Profile[];

    constructor(private seedDataService: SeedDataService, private fb: FormBuilder,
        private confirmationService: ConfirmationService, private profileDataService: ProfileDataService) {

        this.bussinessUnit = new BusinessUnit();
        var tree = [];
       

        var tree = [];

    }


    public BusinessUnitActionType = {
        AddNew: 'Add',
        Edit: 'Update',
        Delete: 'Remove'
    };

	nodeSelect(event: any) {
        //  window.setTimeout(

        if (this.selectedNodes.parentID == 0) {
            this.addDisable = false;
            this.editDisable = true;
            this.deleteDisable = true;
        }
        else {
            this.addDisable = false;
            this.editDisable = false;
            this.deleteDisable = false;
        }




         console.log(this.selectedNodes);


    }
	nodeSelect1(event: any) {
        //  window.setTimeout(
        clearTimeout(this.timer);
        this.IsDoubleClick = true;
        this.EDIT();
        // console.log(this.selectedNodes);

    }
    ngOnInit() {

        this.loading = false;
        this.IsDoubleClick = false;
        this.userform = this.fb.group({
            'unitName': ["", Validators.required],
            'hrBusinessParterSelectItem': ["",],
            'unitManagerTeamMemberSelectedItem': ["",]
            
        });
        this.initialize();
    }

    initialize(){
        
        
        this.seedDataService.GetDeliveryUnitData(0).subscribe((trees: TreeNode[]) => {
            console.log('trees are:', trees);
            this.files = trees;
            console.log("this.files: ", this.files);
            this.expandAll();
        });

        var tree = [];
        this.seedDataService.GetDeliveryUnitData(0).subscribe((trees: TreeNode[]) => {

            this.files = trees;
            //console.log(this.files);
            this.expandAll();
        });
        this.profileDataService.GetHRTeamMembers().subscribe((profiles: Profile[]) => {
            this.profiles = profiles;
            let data = this.renamePropertyNames(this.profiles, "None");
            
            this.hrBusinessParterSelectItem = data;
        });

        this.profileDataService.GetUnitManagerTeamMembers().subscribe((profiles: Profile[]) => {
            console.log('profiles: ', profiles);
            this.profiles = profiles;
            let data = this.renamePropertyNames(this.profiles, "None");
            this.unitManagerTeamMemberSelectedItem = data;
            console.log('unitManagerTeamMemberSelectedItem:', this.unitManagerTeamMemberSelectedItem);
        });
        var tree = [];

    }

    Cancel() {
        this.modelDialoglDisplay = false;
        //this.modelDialoglDisplayDelete = false;
    }

    ADD() {
        this.userform = this.fb.group({
            'unitName': ["", Validators.required],
            'hrBusinessParterSelectItem': ["",],
            'unitManagerTeamMemberSelectedItem': ["",]

        });
        this.loading = false;
        this.ButtonCaption = "Add";
        this.Label = "Add Unit";
        this.newBusinessUnit = true;
        this.modelDialoglDisplay = true;
        this.bussinessUnit.unitName = "";
        this.bussinessUnit.hrBusinessParterID = null;
        this.bussinessUnit.unitManagerID = null;
        // this.ngOnInit();

    }
    EDIT() { 
        this.loading = false;
        this.Label = "Edit Unit";
        this.ButtonCaption = "Save";
        // alert(this.selectedNodes.label)
        console.log('this.selectedNodes is: ', this.selectedNodes);
        this.newBusinessUnit = false;
        this.modelDialoglDisplay = true;
        this.bussinessUnit.unitName = this.selectedNodes.label;
        this.bussinessUnit.hrBusinessParterID = this.selectedNodes.hrBusinessParterID;
        this.bussinessUnit.unitManagerID = this.selectedNodes.unitManagerID;
        //this.ngOnInit();
    }

    PerformBusinessUnitAction(value: any) {
        this.loading = true;
        console.log('this.bussinessUnitzz: ', this.bussinessUnit);
        //alert(this.newBusinessUnit);
        if (this.newBusinessUnit) {
            //alert(this.selectedNodes.name);
           
            this.AddFor = "Add New Unit: " + this.selectedNodes.label;
            this.seedDataService.SaveDeliveryUnitData(this.selectedNodes.id, value.unitName, 0, this.bussinessUnit.hrBusinessParterID, this.bussinessUnit.unitManagerID).subscribe((data) => {
                this.modelDialoglDisplay = false;
                //this.ngOnInit();
                this.initialize();
                this.loading = false;
            });

        }
        else {
            this.AddFor = "Edit Unit: " + this.selectedNodes.label;
            this.seedDataService.SaveDeliveryUnitData(this.selectedNodes.parentID, value.unitName, this.selectedNodes.id, this.bussinessUnit.hrBusinessParterID, this.bussinessUnit.unitManagerID).subscribe((data) => {
                this.modelDialoglDisplay = false;
                //this.ngOnInit();
                this.initialize();
            });
        }


    }
    expandAll() {
        this.files.forEach(node => {
            this.expandRecursive(node, true);
        });
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach(childNode => {

                if (childNode.children != undefined && childNode.children.length > 0) {
                    this.expandRecursive(childNode, isExpand);
                }
            });
        }
    }
    DELETE() {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
                this.seedDataService.DeleteDeliveryUnitData(this.selectedNodes.id).subscribe((data) => {
                    this.modelDialoglDisplay = false;
                    var tree = [];
                    //this.ngOnInit();
                    this.initialize();
                    this.msgs = [];
                    this.msgs.push({
                        severity: 'info', summary: 'Confirmed', detail: 'Node Deleted successfully !'
                    });
                });

            }
        });
    }

	renamePropertyNames(json: any, _firstOption: any) {
        var obj = json;

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {


                objddl.push({
                    'label': obj[i]["firstName"] + " " + obj[i]["lastName"] + " (" + obj[i]["teamMemberCode"] + ")"
                    , 'value': obj[i]["id"]
                });

            }
        }
        return objddl;
    }

}
class PrimeBusinessUnit implements BusinessUnit {
    constructor(
		public id?: any,
		public parentID?: any,
		public name?: any,
		public active?: any,
		public unitName?: any,
		public hrBusinessParterID?: any,
		public unitManagerID?: any
    ) { }
}






// WEBPACK FOOTER //
// ./src/app/Components/DeliveryUnit/delivery.unit.ts